import fitlerTypes from '../type/filter-item.type'

export default [
  {
    title: fitlerTypes.checkbox.title,
    value: fitlerTypes.checkbox.value,
  },
  {
    title: fitlerTypes.range.title,
    value: fitlerTypes.range.value,
  },
]